import React from 'react';
import { AuthContext } from '../context';
import { useCnAuth } from './useCnAuth';

interface CnAuthProviderProperties {
  children: React.ReactNode;
}

export const CnAuthProvider: React.FC<CnAuthProviderProperties> = ({ children }) => {
  const authService = useCnAuth();
  return <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>;
};
